export default __webpack_public_path__ + "static/media/coins1.de2cf74a.mp3";